import React, { useEffect, useState } from "react";
import { api, fileUrl } from "../lib/api";
import { Dialog, DialogContent } from "./ui/dialog";

const TIER_LABEL = { premium: "Premium", gold: "Gold", standard: "Standard" };
const TIER_RING = {
  premium: { background: "conic-gradient(from 180deg at 50% 50%, #D4AF37, #F4D772, #CD7F32, #D4AF37)" },
  gold: { background: "conic-gradient(from 180deg at 50% 50%, #C0C2C6, #E8E9EB, #8B8C90, #C0C2C6)" },
  standard: { background: "conic-gradient(from 180deg at 50% 50%, #B8B2A0, #E5E2D9, #8B8779, #B8B2A0)" },
};

const StoryBar = () => {
  const [groups, setGroups] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/stories").then((r) => setGroups(r.data)).catch(() => {});
  }, []);

  if (!groups.length) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="text-xs text-[#6B6A63] tracking-[0.2em] uppercase mb-2">Historias del día</div>
        <div className="text-sm text-[#6B6A63]">Aún no hay historias hoy.</div>
      </div>
    );
  }

  // Group + sort by tier order
  const byTier = { premium: [], gold: [], standard: [] };
  groups.forEach((g) => {
    const t = g.tier || "standard";
    if (byTier[t]) byTier[t].push(g);
  });

  const renderGroup = (g) => (
    <button
      key={g.angel_id}
      data-testid={`story-${g.angel_id}`}
      onClick={() => setActive({ group: g, idx: 0 })}
      className="flex flex-col items-center shrink-0 gap-1"
    >
      <div className="rounded-full p-[2.5px]" style={TIER_RING[g.tier || "standard"]}>
        <div className="bg-[#FAF9F6] p-[2px] rounded-full">
          <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-[#F3F1EA] overflow-hidden">
            {g.main_photo_path ? (
              <img src={fileUrl(g.main_photo_path)} alt={g.artistic_name} className="w-full h-full object-cover" />
            ) : null}
          </div>
        </div>
      </div>
      <div className="text-xs text-[#1A2118] max-w-[80px] truncate">{g.artistic_name}</div>
    </button>
  );

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 space-y-4">
      {["premium", "gold", "standard"].map((tier) => byTier[tier].length > 0 && (
        <div key={tier}>
          <div className="text-xs tracking-[0.25em] uppercase mb-2 flex items-center gap-2"
               style={{ color: tier === "premium" ? "#B8943A" : tier === "gold" ? "#7C7C81" : "#6B6A63" }}>
            <span className="inline-block w-2 h-2 rounded-full"
                  style={{ background: tier === "premium" ? "#D4AF37" : tier === "gold" ? "#A8A9AD" : "#B8B2A0" }} />
            Historias {TIER_LABEL[tier]}
          </div>
          <div data-testid={`story-bar-${tier}`} className="flex gap-4 overflow-x-auto no-scrollbar pb-2">
            {byTier[tier].map(renderGroup)}
          </div>
        </div>
      ))}

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-md bg-black border-none p-0 overflow-hidden">
          {active && (() => {
            const cur = active.group.stories[active.idx];
            const path = cur.image_path;
            const isVid = /\.(mp4|mov|webm)(\?|$)/i.test(path || "");
            return (
              <div className="relative">
                {isVid ? (
                  <video src={fileUrl(path)} className="w-full h-[80vh] object-contain bg-black"
                         autoPlay muted playsInline controls={false}
                         onEnded={() => setActive((a) => (a.idx + 1 >= a.group.stories.length ? null : { ...a, idx: a.idx + 1 }))}
                         onContextMenu={(e) => e.preventDefault()} />
                ) : (
                  <img src={fileUrl(path)} alt="story" className="w-full h-[80vh] object-contain bg-black no-save"
                       draggable={false} onContextMenu={(e) => e.preventDefault()} />
                )}
                <div className="absolute top-2 left-2 right-2 flex gap-1">
                  {active.group.stories.map((_, i) => (
                    <div key={i} className={`h-0.5 flex-1 rounded ${i <= active.idx ? "bg-white" : "bg-white/30"}`} />
                  ))}
                </div>
                <div className="absolute inset-0 flex">
                  <button className="flex-1" onClick={() => setActive((a) => ({ ...a, idx: Math.max(0, a.idx - 1) }))} />
                  <button className="flex-1" onClick={() => setActive((a) => (a.idx + 1 >= a.group.stories.length ? null : { ...a, idx: a.idx + 1 }))} />
                </div>
              </div>
            );
          })()}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default StoryBar;
